(function bnrMessage() {
    var w;
    var d;
    if (window instanceof Window && document instanceof Document) {
        w = window;
        d = document;
    }
    else {
        return;
    }
    var className = "bnr-message";
    if (w["__" + className + "Loaded"])
        return;
    w["__" + className + "Loaded"] = true;
    var tempSlots = [
        ["Home/Header", ".leaderboard-container", "afterbegin", "^/$"],
        ["Home/Mid1", ".section-ads .ad-wrapper", "beforeend", "^/$"],
        ["Home/Mid2", ".section-brandstories", "afterbegin", "^/$"],
        ["Home/Mid3", ".section-specials", "afterbegin", "^/$"],
        ["Home/Mid4", ".section-specials", "beforeend", "^/$"],
        [
            "Home/Mid5",
            ".section-latest-podcast .ad-wrapper.show-desktop",
            "beforebegin",
            "^/$",
        ],
        [
            "Home/Mid6",
            ".section-latest-podcast .ad-wrapper.show-desktop ~ .ad-wrapper.show-desktop",
            "beforebegin",
            "^/$",
        ],
        [
            "Podcastoverzicht/Header",
            ".leaderboard-container",
            "afterbegin",
            "^/podcasts",
        ],
        ["Podcastoverzicht/Mid1", ".main > aside", "beforeend", "^/podcasts"],
        [
            "Podcastoverzicht/Desktop_Advertorial",
            ".teaser-list article:nth-of-type(3)",
            "afterend",
            "^/podcasts",
        ],
        [
            "BrandstoriesOverzicht/Header",
            ".leaderboard-container",
            "afterbegin",
            "^/vanonzepartners$",
        ],
        [
            "BrandstoriesOverzicht/Mid1",
            ".main > aside",
            "beforeend",
            "^/vanonzepartners$",
        ],
        [
            "BrandstoriesOverzicht/Desktop_Advertorial",
            ".teaser-list article:nth-of-type(3)",
            "afterend",
            "^/vanonzepartners$",
        ],
        [
            "BrandstoriesDetail/Header",
            ".leaderboard-container",
            "afterbegin",
            "^/vanonzepartners/[^/]+$",
        ],
        [
            "BrandstoriesDetail/Sponsorcontent_1",
            ".main > aside",
            "beforeend",
            "^/vanonzepartners/[^/]+$",
        ],
        [
            "BrandstoriesDetail/Sponsorcontent_2",
            ".main > aside",
            "beforeend",
            "^/vanonzepartners/[^/]+$",
        ],
        [
            "BrandstoriesDetail/Sponsorcontent_3",
            ".main > aside",
            "beforeend",
            "^/vanonzepartners/[^/]+$",
        ],
        [
            "BrandstoriesDetail/Mid1",
            ".main > aside",
            "beforeend",
            "^/vanonzepartners/[^/]+$",
        ],
        [
            "BrandstoriesDetail/Desktop_Advertorial",
            ".teaser-list article:nth-of-type(3)",
            "afterend",
            "^/vanonzepartners/[^/]+$",
        ],
        [
            "BrandstoriesAflevering/Header",
            ".leaderboard-container",
            "afterbegin",
            "^/vanonzepartners/.+/.+",
        ],
        [
            "BrandstoriesAflevering/Sponsorcontent_1",
            ".main > aside",
            "beforeend",
            "^/vanonzepartners/.+/.+",
        ],
        [
            "BrandstoriesAflevering/Sponsorcontent_2",
            ".main > aside",
            "beforeend",
            "^/vanonzepartners/.+/.+",
        ],
        [
            "BrandstoriesAflevering/Sponsorcontent_3",
            ".main > aside",
            "beforeend",
            "^/vanonzepartners/.+/.+",
        ],
        [
            "BrandstoriesAflevering/Mid1",
            ".main > aside",
            "beforeend",
            "^/vanonzepartners/.+/.+",
        ],
        [
            "PodcastDetail/Header",
            ".leaderboard-container",
            "afterbegin",
            "^/podcast/[^/]+$",
        ],
        [
            "PodcastDetail/Sponsorcontent_1",
            ".main > aside",
            "beforeend",
            "^/podcast/[^/]+$",
        ],
        [
            "PodcastDetail/Sponsorcontent_2",
            ".main > aside",
            "beforeend",
            "^/podcast/[^/]+$",
        ],
        [
            "PodcastDetail/Sponsorcontent_3",
            ".main > aside",
            "beforeend",
            "^/podcast/[^/]+$",
        ],
        ["PodcastDetail/Mid1", ".main > aside", "beforeend", "^/podcast/[^/]+$"],
        [
            "PodcastDetail/Desktop_Advertorial",
            ".teaser-list article:nth-of-type(3)",
            "afterend",
            "^/podcast/[^/]+$",
        ],
        [
            "PodcastAflevering/Header",
            ".leaderboard-container",
            "afterbegin",
            "^/podcast/.+/.+",
        ],
        [
            "PodcastAflevering/Sponsorcontent_1",
            ".main > aside",
            "beforeend",
            "^/podcast/.+/.+",
        ],
        [
            "PodcastAflevering/Sponsorcontent_2",
            ".main > aside",
            "beforeend",
            "^/podcast/.+/.+",
        ],
        [
            "PodcastAflevering/Sponsorcontent_3",
            ".main > aside",
            "beforeend",
            "^/podcast/.+/.+",
        ],
        ["PodcastAflevering/Mid1", ".main > aside", "beforeend", "^/podcast/.+/.+"],
        ["Nieuws/Header", ".leaderboard-container", "afterbegin", "^/nieuws$"],
        ["Nieuws/Mid1", ".live-player-container", "afterend", "^/nieuws$"],
        ["Dossier/Header", ".leaderboard-container", "afterbegin", "^/dossier"],
        ["Dossier/Mid1", ".live-player-container", "afterend", "^/dossier"],
        ["Auteur/Header", ".leaderboard-container", "afterbegin", "^/auteur"],
        ["Auteur/Mid1", ".main > aside", "beforeend", "^/auteur"],
        ["Artikel/Header", ".leaderboard-container", "afterbegin", "^/nieuws/.+"],
        ["Artikel/Mid1", ".main > aside", "beforeend", "^/nieuws/.+"],
        ["Artikel/Mid2", "article", "beforeend", "^/nieuws/.+"],
        ["Gemist/Header", ".leaderboard-container", "afterbegin", "^/gemist"],
        ["Gemist/Mid1", ".search-by-recent", "afterend", "^/gemist"],
        [
            "Zoekresultaten/Header",
            ".leaderboard-container",
            "afterbegin",
            "^/search",
        ],
        ["Zoekresultaten/Mid1", ".main > aside", "beforeend", "^/search"],
        ["Zoekresultaten/Mid2", "article:nth-of-type(3)", "afterend", "^/search"],
        ["Zoekresultaten/Mid3", "article:nth-of-type(6)", "afterend", "^/search"],
        ["Player/Mid1", ".intro", "afterend", "^/player/live"],
        ["Player/Preroll", "footer", "beforebegin", "^/player/live"],
        ["Player/Mid1", ".intro", "afterend", "^/player/audio"],
        ["Player/Mid1", ".intro", "afterend", "^/player/kijk"],
        ["Player/Preroll", "footer", "beforebegin", "^/player/kijk"],
    ];
    if (w.location.hostname.match(/^acc\.bnr\.nl/)) {
        tempSlots.push([
            "Home/Test2022",
            ".section-news-fragment",
            "beforeend",
            "^/$",
        ]);
    }
    var prefix = "7905/BNR.nl_2021".split("/");
    var labelAd = "Advertentie";
    var labelAdvertorial = "Van onze partners";
    var log = [];
    var mediaPlatform = "browser";
    var domain = "bnr.nl";
    var tcfKey = "tcf.consent";
    var tcfSettings = [{ vendorId: 755 }];
    var defaultSettings = {
        lazyLoad: 200,
    };
    var renderCallbacks = {
        "/Header": function () {
            w.scrollTo(w.scrollX, w.scrollY - 1);
            w.scrollTo(w.scrollX, w.scrollY + 1);
        },
    };
    var devSubs = {
        development: ["dev", "local"],
        acceptatie: ["acc"],
    };
    var slotMapping = {};
    var refreshOnResize = !w.location.search.match(/refreshOnResize=off/);
    var threshold = 200;
    var lazySlots = [];
    var lazyEls = [];
    var directSlots = [];
    var breakpoints = {};
    var breakpoint = 0;
    var n = 0;
    var settings = {};
    var ab;
    var _prefix = function (slot) {
        var p = slot.split("/");
        var s = [];
        for (var i = 3; i >= 0; i--) {
            var v = p.pop();
            s.push(v ? v : prefix[i]);
        }
        return "/" + s.reverse().join("/");
    };
    var _settings = function () {
        var start = +new Date();
        _setSize([
            "Home/Header",
            "Podcastoverzicht/Header",
            "BrandstoriesOverzicht/Header",
            "BrandstoriesDetail/Header",
            "BrandstoriesAflevering/Header",
            "PodcastDetail/Header",
            "PodcastAflevering/Header",
            "Nieuws/Header",
            "Dossier/Header",
            "Auteur/Header",
            "Artikel/Header",
            "Gemist/Header",
            "Zoekresultaten/Header",
        ], {
            0: ["320x100", "320x50", "300x100", "300x50"],
            599: ["468x60", "320x100", "320x50", "300x100", "300x50"],
            728: ["728x90", "468x60"],
            861: ["728x90", "468x60"],
            991: ["1024x250", "1024x122", "970x250", "970x90", "728x90"],
            1024: ["1024x250", "1024x122", "970x250", "970x90", "728x90"],
        });
        _setSize(["Home/Mid1"], {
            0: ['320x400', '320x100', '320x50', '300x250', '300x100', '300x50'],
            599: [
                '468x60',
                '320x400',
                '320x100',
                '320x50',
                '300x250',
                '300x100',
                '300x50',
            ],
            728: ['320x400', '300x250'],
            861: ['320x400', '300x250'],
            991: ['320x400'],
            1024: ['320x400', '300x600', '300x250'],
        });
        _setSize(["Home/Mid2", "Home/Mid3", "Home/Mid4"], {
            0: ['320x400', '320x100', '320x50', '300x250', '300x100', '300x50'],
            599: [
                '468x60',
                '320x400',
                '320x100',
                '320x50',
                '300x250',
                '300x100',
                '300x50',
            ],
            728: ['728x90', '468x60', '320x400'],
            861: ['728x90', '468x60', '320x400'],
            991: ['970x250', '970x90', '728x90', '320x400'],
            1024: ['970x250', '970x90', '728x90', '320x400'],
        });
        _setSize(["Home/Mid5", "Home/Mid6"], {
            0: ["fluid"],
            599: ["fluid"],
            728: ["fluid"],
            861: ["fluid"],
            991: ["fluid"],
            1024: ["fluid"],
        });
        _setSize(["Home/Test2022"], {
            0: ["fluid"],
            599: ["fluid"],
            728: ["fluid"],
            861: ["fluid"],
            991: ["fluid"],
            1024: ["fluid"],
        });
        _setSize([
            "Podcastoverzicht/Desktop_Advertorial",
            "BrandstoriesOverzicht/Desktop_Advertorial",
            "BrandstoriesDetail/Desktop_Advertorial",
            "PodcastDetail/Desktop_Advertorial",
        ], {
            0: [],
            599: [],
            728: [],
            861: ["fluid"],
            991: ["fluid"],
            1024: ["fluid"],
        });
        _setSize([
            "Podcastoverzicht/Mid1",
            "BrandstoriesOverzicht/Mid1",
            "BrandstoriesDetail/Mid1",
            "BrandstoriesDetail/Mid2",
            "BrandstoriesAflevering/Mid1",
            "BrandstoriesAflevering/Mid2",
            "PodcastDetail/Mid1",
            "PodcastAflevering/Mid1",
            "Nieuws/Mid1",
            "Dossier/Mid1",
            "Auteur/Mid1",
            "Artikel/Mid1",
            "Zoekresultaten/Mid1",
        ], {
            0: ['320x400'],
            599: ['320x400'],
            728: ['320x400'],
            861: ['320x400', '300x600', '300x250'],
            991: ['320x400', '300x600', '300x250'],
            1024: ['320x400', '300x600', '300x250'],
        });
        _setSize([
            "BrandstoriesDetail/Sponsorcontent_1",
            "BrandstoriesDetail/Sponsorcontent_2",
            "BrandstoriesDetail/Sponsorcontent_3",
            "BrandstoriesAflevering/Sponsorcontent_1",
            "BrandstoriesAflevering/Sponsorcontent_2",
            "BrandstoriesAflevering/Sponsorcontent_3",
            "PodcastDetail/Sponsorcontent_1",
            "PodcastDetail/Sponsorcontent_2",
            "PodcastDetail/Sponsorcontent_3",
            "PodcastAflevering/Sponsorcontent_1",
            "PodcastAflevering/Sponsorcontent_2",
            "PodcastAflevering/Sponsorcontent_3",
        ], {
            0: [],
            599: [],
            728: [],
            861: ["300x220", "300x330", "300x700"],
            991: ["300x220", "300x330", "300x700"],
            1024: ["300x220", "300x330", "300x700"],
        });
        _setSize(["Artikel/Mid2"], {
            0: ["320x180", "300x250"],
            599: ["600x340", "300x250"],
            728: ["600x340", "300x250"],
            861: ["600x340", "300x250"],
            991: ["600x340", "300x250"],
            1024: ["600x340", "300x250"],
        });
        _setSize(["Gemist/Mid1", "Player/Mid1"], {
            0: ["300x250"],
            599: ["300x250"],
            728: ["300x250"],
            861: ["300x250"],
            991: ["300x250"],
            1024: ["300x250"],
        });
        _setSize(["Zoekresultaten/Mid2", "Zoekresultaten/Mid3"], {
            0: [
                "fluid",
                "320x400",
                "320x250",
                "320x240",
                "320x100",
                "320x50",
                "300x250",
                "300x100",
                "300x50",
            ],
            599: ["fluid"],
            728: ["fluid"],
            861: ["fluid"],
            991: ["fluid"],
            1024: ["fluid"],
        });
        _setSize(["Player/Preroll"], {
            0: ["12x20"],
            599: ["12x20"],
            728: ["12x20"],
            861: ["12x20"],
            991: ["12x20"],
            1024: ["12x20"],
        });
        _setSetting("Home/Mid(2|3|4|5|6)", {
            lazyLoad: {
                0: 100,
                599: 200,
                728: 100,
                861: 100,
                991: 100,
                1024: 100,
            },
        });
        _setSetting(".*/Header", {
            lazyLoad: false,
        });
        _setSetting("(Podcastoverzicht|BrandstoriesOverzicht|BrandstoriesDetail|PodcastDetail)/Desktop_Advertorial", {
            lazyLoad: 100,
        });
        _setSetting("Gemist/Mid1", {
            lazyLoad: false,
        });
        _setSetting("Player/(Mid1|Preroll)", {
            lazyLoad: false,
        });
        console.debug("[bnr-message]", "exec time [_settings]", +new Date() - start);
    };
    var _setSetting = function (m, obj) {
        var reg = new RegExp("^" + m + "$");
        for (var i in settings) {
            if (settings.hasOwnProperty(i) && i.match(reg)) {
                for (var b in obj) {
                    if (obj.hasOwnProperty(b)) {
                        settings[i][b] = obj[b];
                    }
                }
            }
        }
    };
    var _setSize = function (a, b) {
        var mapping = googletag.sizeMapping();
        for (var i in b) {
            if (b.hasOwnProperty(i)) {
                breakpoints[i] = i;
                for (var j = 0; j < b[i].length; j++) {
                    b[i][j] = b[i][j].split("x").map(function (t) {
                        return isNaN(t) ? t : +t;
                    });
                    if (b[i][j].length === 1)
                        b[i][j] = b[i][j][0];
                }
                mapping.addSize([+i, 0], b[i]);
            }
        }
        mapping = mapping.build();
        for (var i = 0; i < a.length; i++) {
            var currentSettings = settings[a[i]];
            settings[a[i]] = {
                mapping: mapping,
            };
            for (var f in defaultSettings) {
                if (defaultSettings.hasOwnProperty(f)) {
                    settings[a[i]][f] = defaultSettings[f];
                }
            }
        }
    };
    var _getBreakPoint = function () {
        var points = Object.keys(breakpoints).sort(function (a, b) {
            return b - a;
        });
        var point = 0;
        for (var i = 0; i < points.length; i++) {
            if (w.matchMedia("(min-width: " + points[i] + "px)").matches) {
                point = points[i];
                break;
            }
        }
        return point;
    };
    var _load = function (src) {
        w.googletag = w.googletag || {};
        googletag.cmd = googletag.cmd || [];
        var node = document.getElementsByTagName("script")[0];
        var el = document.createElement("script");
        el.id = "google-adslots";
        el.async = true;
        el.type = "text/javascript";
        el.src = src;
        el.onerror = _error;
        node.parentNode.insertBefore(el, node);
        var styles = ".___>div>div{position:relative;padding-top:32px!important;margin-bottom:24px!important}.___>div>div::before{position:absolute;z-index:2;left:0;top:9px;right:0;content:'" +
            labelAd +
            '\';display:block;text-align:center;font-size:14px;color:#66767d;font-family:sans-serif}.___>div>div:empty{display:none}.___>div>div[style*="height: 0%"]::before,.___>div>div[style*="height: 0;"]::before{display:none}';
        styles += ".___-ghost{display:none!important}";
        styles += ".leaderboard-container {overflow: hidden}";
        styles += ".home-page .section.section-ads {background:none}";
        styles +=
            '@media(min-width: 1024px){.home-page .section.section-ads{position:sticky;top:6rem;margin-bottom:7.25rem;margin-top:1rem}[data-slot="Podcastoverzicht/Mid1"],[data-slot="BrandstoriesOverzicht/Mid1"],[data-slot="BrandstoriesAflevering/Mid1"],[data-slot="BrandstoriesDetail/Mid1"],[data-slot="PodcastDetail/Mid1"], [data-slot="PodcastAflevering/Mid1"], [data-slot="Dossier/Mid1"], [data-slot="Auteur/Mid1"], [data-slot="Artikel/Mid1"], [data-slot="Zoekresultaten/Mid1"]{position:sticky;top:6rem}.main>aside>.___[data-slot="Zoekresultaten/Mid1"]:last-child{margin-bottom: 84px!important}}';
        styles +=
            "body .leaderboard-container,body .section-ads{display:block!important}";
        node.insertAdjacentHTML("afterend", '<style type="text/css">' + styles.replace(/___/g, className) + "</style>");
    };
    var _render = function (e) {
        var ids = [];
        _cleanActiveSlots();
        var els = d.querySelectorAll("." + className + "[data-slot]:not(." + className + "-processed)");
        if (!els.length)
            return;
        for (var i = 0; i < els.length; i++) {
            if (slotMapping.hasOwnProperty(els[i].dataset.slot)) {
                els[i].dataset.slot = slotMapping[els[i].dataset.slot];
            }
            var unit = els[i].dataset.slot, id = className + "-" + n++, options = settings[unit];
            els[i].classList.add(className + "-processed");
            if (!options)
                continue;
            els[i].innerHTML = '<div id="' + id + '"></div>';
            els[i].classList.add(className + "-" + unit.replace(/\//g, "-").toLowerCase());
            els[i].classList.add(className + "-page-" + unit.split("/").shift().toLowerCase());
            els[i].classList.add(className + "-type-" + unit.split("/").pop().toLowerCase());
            els[i].classList.add(className + "-constiant-" + ab.toLowerCase());
            var slot = googletag
                .defineSlot(_prefix(unit), [], ids[ids.push(id) - 1])
                .defineSizeMapping(options.mapping)
                .addService(googletag.pubads());
            if (typeof options.lazyLoad == "number" ||
                (typeof options.lazyLoad == "object" &&
                    typeof options.lazyLoad[breakpoint] == "number")) {
                _event("lazyslot", unit, true);
                lazySlots.push(slot);
                lazyEls.push(els[i]);
            }
            else {
                _event("directslot", unit, true);
                directSlots.push(slot);
            }
        }
        if (directSlots.length) {
            googletag.pubads().refresh(directSlots, { changeCorrelator: false });
            directSlots = [];
        }
    };
    var _impressionViewable = function (event) {
        if ("object" == typeof dataLayer) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "bnr-ads_browser",
                eventAction: "viewable",
                eventLabel: event.slot.getAdUnitPath().split("/").slice(-2).join("/"),
                eventValue: undefined,
                eventNonInt: true,
            });
        }
        _event("viewable", event.slot.getAdUnitPath(), true);
    };
    var _slotRequested = function (event) {
        _event("requested", event.slot.getAdUnitPath(), true);
    };
    var _slotRendered = function (event) {
        var unit = event.slot.getAdUnitPath();
        _event(event.isEmpty ? "collapsed" : "rendered", unit, true);
        if (!event.isEmpty && ab) {
            _event("constiant-" + ab, unit, true);
        }
        var slotEl = document.querySelector("#" + event.slot.getSlotElementId() + " > div");
        if (slotEl) {
            slotEl.parentElement.parentElement.classList.add(className + "-rendered");
            slotEl.parentElement.parentElement.classList[event.isEmpty ? "add" : "remove"](className + "-collapsed");
            for (var i in renderCallbacks) {
                if (renderCallbacks.hasOwnProperty(i) && unit.match(new RegExp(i))) {
                    renderCallbacks[i].call(slotEl.parentNode.parentNode, event);
                }
            }
        }
        if (!event.isEmpty &&
            slotEl &&
            slotEl.getAttribute("style") &&
            slotEl.getAttribute("style").match(/\!important/i)) {
            slotEl.setAttribute("style", slotEl.getAttribute("style").replace(/\!important/gi, ""));
        }
        var el = d.querySelector("." + className + "s #" + event.slot.getSlotElementId() + " iframe");
        if (!el)
            return;
        el.addEventListener("load", function () {
            el.style.minHeight = "1px";
        });
    };
    var _inView = function () {
        var start = +new Date();
        if (!lazyEls.length)
            return;
        var els = [];
        var h = w.innerHeight || d.clientHeight;
        var i = lazyEls.length;
        while (i--) {
            var bcr = lazyEls[i].getBoundingClientRect();
            var unit = lazyEls[i].dataset.slot;
            var options = settings[unit];
            var m = options.lazyLoad[breakpoint] || options.lazyLoad;
            var t = 0 - m;
            var b = h + m;
            if (bcr.top >= t && bcr.top <= b && !document.hidden) {
                els.push(lazySlots[i]);
                lazySlots.splice(i, 1);
                lazyEls.splice(i, 1);
                _event("inview", unit, true);
            }
        }
        if (els.length) {
            googletag.pubads().refresh(els, { changeCorrelator: false });
        }
        requestAnimationFrame(_inView);
        console.debug("[bnr-message]", "exec time [_inView]", +new Date() - start);
    };
    var _cleanActiveSlots = function () {
        var activeSlots = googletag.pubads().getSlots();
        if (!activeSlots.length)
            return;
        var els = [], remove = [];
        for (var i = 0; i < activeSlots.length; i++) {
            try {
                var id = activeSlots[i].getSlotElementId();
                if (!document.getElementById(id)) {
                    remove.push(activeSlots[i]);
                    var el = document.createElement("div");
                    el.id = id;
                    el.classList.add(className + "-ghost");
                    document.body.appendChild(el);
                    _event("removed", activeSlots[i].getAdUnitPath(), true);
                }
            }
            catch (e) {
                _event("removed", "unknown", true);
            }
        }
        if (remove.length)
            googletag.destroySlots(remove);
    };
    var _resize = function () {
        var i;
        w.addEventListener("resize", function () {
            clearTimeout(i);
            i = setTimeout(function () {
                var point = _getBreakPoint();
                if (point != breakpoint) {
                    breakpoint = point;
                    if (refreshOnResize) {
                        googletag.pubads().refresh(googletag.pubads().getSlots(), {
                            changeCorrelator: false,
                        });
                    }
                }
            }, 100);
        });
    };
    var _targeting = function () {
        var data = w.siteData, sub = w.location.hostname.split(".").reverse()[2], environment = "production";
        var _set = function (key, value) {
            if (typeof value != "undefined") {
                googletag.pubads().setTargeting(key, "" + value);
            }
        };
        var setTargetingKeys = function () {
            if (sub)
                for (var i in devSubs)
                    if (devSubs.hasOwnProperty(i) && devSubs[i].indexOf(sub) > -1) {
                        environment = i;
                        break;
                    }
            _set("environment", environment);
            _set("mediaPlatform", "browser");
            _set("native", "false");
            if (ab)
                _set("ABtest", ab);
            if (typeof data === "object") {
                _set("dartSection", data.section);
                _set("dartSubSection", data.subSection);
                _set("title", data.title);
                _set("tag", data.pageTags);
                _set("articleType", data.articleType);
                _set("articleId", data.articleId);
                _set("articleSource", data.articleSource);
                if (data.pageType == "zoeken") {
                    var q = d.querySelector("#q");
                    q && _set("searchString", q.value);
                }
            }
        };
        setTargetingKeys();
        try {
            var queryKeys = w.location.search.match(/bnr-message-targeting=(.*)/);
            if (queryKeys) {
                if (queryKeys[1] == "" || queryKeys[1] == "null")
                    w.sessionStorage.removeItem(className + "-debugKeys");
                else
                    w.sessionStorage.setItem(className + "-debugKeys", queryKeys[1]);
            }
            var debugKeys = w.sessionStorage.getItem(className + "-debugKeys");
            if (debugKeys) {
                debugKeys = JSON.parse('{"' + decodeURIComponent(debugKeys).replace(/([,:])/g, '"$1"') + '"}');
                for (var l in debugKeys) {
                    if (debugKeys.hasOwnProperty(l)) {
                        _set(l, debugKeys[l]);
                    }
                }
            }
        }
        catch (err) { }
    };
    var _init = function () {
        var bh = 0;
        var dt = 1000;
        var de = 5000;
        var bc = new Date().getTime();
        var dc = bc;
        if (w.nativeAppPlatform)
            mediaPlatform = "app_" + w.nativeAppPlatform.toLowerCase();
        breakpoint = _getBreakPoint();
        var _checkHeight = function () {
            var now = new Date().getTime();
            if (bh != d.scrollHeight) {
                bh = d.scrollHeight;
                bc = now;
            }
            else if (now - bc > dt || now - dc > de) {
                _inView();
                return;
            }
            w.requestAnimationFrame(_checkHeight);
        };
        _checkHeight();
        _render();
        var container = d.querySelector("main, .content-area");
        if (container) {
            var slotWatcher = new MutationObserver(_render);
            slotWatcher.observe(container, { childList: true, subtree: true });
        }
        _resize();
    };
    var _tcf = function () {
        __tcfapi("getTCData", 2, function (e) {
            var consent = tcfSettings.every(function (setting) {
                return e.vendor.consents[setting["vendorId"]] === true;
            });
            if (window.localStorage) {
                window.localStorage.setItem(tcfKey, JSON.stringify(consent));
            }
            if (consent === true) {
                _gpt();
            }
            else {
                _alt();
            }
        });
    };
    try {
        var abKey = domain.replace(/\./g, "") + "-ab";
        ab = document.cookie.match(new RegExp("(^| )_" + abKey + "=([^;]+)", "i"));
        if (ab && ab[2])
            ab = ab[2];
        else
            ab = "AB"[Math.round(Math.random())];
        document.cookie =
            "_" +
                abKey +
                "=" +
                ab +
                ";expires=" +
                new Date(new Date().getTime() + 60 * 24 * 60 * 60 * 1000).toUTCString() +
                ";path=/;domain=" +
                domain;
    }
    catch (e) {
        ab = "A";
    }
    var _event = function (action, label, nonInteractive) {
        label = label.split("/").slice(-2).join("/");
        if (log.indexOf(label) === -1)
            return;
        var evt = {
            event: "gaEvent",
            eventCategory: "bnr-ads_" + mediaPlatform,
            eventAction: action,
            eventLabel: label,
            eventValue: undefined,
            eventNonInt: nonInteractive,
        };
        if ("object" == typeof dataLayer) {
            dataLayer.push(evt);
        }
    };
    var _ready = function (e) {
        "interactive" != document.readyState && "complete" != document.readyState
            ? w.requestAnimationFrame(function () {
                _ready(e);
            })
            : e();
    };
    var _tempSlots = function () {
        for (var i = 0; i < tempSlots.length; i++) {
            if (!w.location.pathname.match(new RegExp(tempSlots[i][3])))
                continue;
            var target = d.querySelector(tempSlots[i][1]);
            if (!target)
                continue;
            if (d.querySelector('[data-slot="' + tempSlots[i][0] + '"]'))
                continue;
            target.insertAdjacentHTML(tempSlots[i][2], '<div class="bnr-message" data-slot="' + tempSlots[i][0] + '"></div>');
        }
    };
    _ready(_tempSlots);
    var fired = false;
    var _gpt = function () {
        if (fired)
            return;
        fired = true;
        _load("//securepubads.g.doubleclick.net/tag/js/gpt.js");
        googletag.cmd.push(function () {
            _settings();
            googletag.pubads().disableInitialLoad();
            googletag.pubads().setCentering(true);
            googletag.pubads().enableSingleRequest();
            googletag.pubads().addEventListener("slotRequested", _slotRequested);
            googletag.pubads().addEventListener("slotRenderEnded", _slotRendered);
            googletag
                .pubads()
                .addEventListener("impressionViewable", _impressionViewable);
            _targeting();
            googletag.pubads().setTargeting("limitedAds", "false");
            googletag.enableServices();
            _ready(_init);
        });
    };
    var _alt = function () {
        if (fired)
            return;
        fired = true;
        _load("//pagead2.googlesyndication.com/tag/js/gpt.js");
        googletag.cmd.push(function () {
            _settings();
            googletag.pubads().disableInitialLoad();
            googletag.pubads().setCentering(true);
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setPrivacySettings({ limitedAds: true });
            googletag.pubads().addEventListener("slotRequested", _slotRequested);
            googletag.pubads().addEventListener("slotRenderEnded", _slotRendered);
            googletag
                .pubads()
                .addEventListener("impressionViewable", _impressionViewable);
            _targeting();
            googletag.pubads().setTargeting("limitedAds", "true");
            googletag.enableServices();
            _ready(_init);
        });
    };
    var _hasAdBlock = function () {
        var el = document.createElement("div");
        el.className = "imgad";
        el.style.position = "fixed";
        el.style.pointerEvents = "none";
        el.innerHTML = "";
        el.style.padding = "1rem";
        el.style.opacity = "0";
        document.body.appendChild(el);
        var hasAdBlocker = el.offsetHeight < 8;
        el.parentNode.removeChild(el);
        return hasAdBlocker;
    };
    var _error = function () {
        d.classList.add(className + "-sticky-header-collapsed");
        var els = d.querySelectorAll("[data-slot]");
        for (var i = 0; i < els.length; i++) {
            els[i].classList.add(className + "-blocked");
        }
    };
    if (w.localStorage) {
        var localConsent = JSON.parse(w.localStorage.getItem(tcfKey));
        if (typeof localConsent == "boolean" && localConsent === false) {
            _alt();
        }
    }
    if ("function" == typeof __tcfapi) {
        var start = +new Date();
        _tcf();
        console.debug("[bnr-message]", "exec time [_tcf]", +new Date() - start);
    }
    else {
        var start = +new Date();
        _alt();
        console.debug("[bnr-message]", "exec time [_alt]", +new Date() - start);
    }
})();
